<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5 p-3">
      <div class="card bg-white w-100 p-2">
        <div class="d-flex justify-content-between align-items-center"><h5
            style="font-size: 1.5vw !important; margin: 1vw;">طراحی و مدلسازی</h5>
        </div>
        <hr>
        <br>
        <input style="width: 20vw;" v-model="search_keyword" class="form-control mb-3" type="text"
               placeholder="جستجو بر اساس فرآیند ، کد فرآیند و پست سازمانی...">
        <div class="mb-5" v-if="allItems.length">
          <table class="table table-striped">
            <thead>
            <tr>
              <th style="width: 1vw;">ردیف</th>
              <th class="text-end"> فرآیند</th>
              <th class="text-end"> کد</th>
              <th style="width: 15vw;" class="text-end"> پست سازمانی</th>
              <th style="width: 15vw;" class="text-end"> شماره پرسنلی  </th>
              <th style="width: 5vw;">عملیات</th>
            </tr>
            </thead>
            <tbody v-for="(item, index) in filteredItems">
            <tr>
              <td>{{ index + 1 }}</td>
              <td class="text-end">{{ item.process.title }}</td>
              <td class="text-end">{{ item.process.code }}</td>
              <td class="text-end" v-if="item.process && item.process.organ_post && item.process.organ_post.organizationpost && item.process.organ_post.organizationpost.name">
                {{ item.process && item.process.organ_post && item.process.organ_post.organizationpost && item.process.organ_post.organizationpost.name }}
              </td>
              <td v-else>--</td>
              <td class="text-end" v-if="item.process && item.process.organ_post && item.process.organ_post.organizationpost && item.process.organ_post.organizationpost.name">
                {{ item.process && item.process.organ_post && item.process.organ_post.organizationpost && item.process.organ_post.organizationpost.id }}
              </td>
              <td v-else>--</td>
              <td>
                <div class="d-flex justify-content-center align-items-center">
                  <a :href="`${this.download_url}/DesignAndModeling/show/${this.id_user}/${item.id}?token=${$cookies.get('id_login')}`">
                    <img
                        class="table-edit-img"
                        src="../../../assets/img/pen.svg"
                        alt="edit"></a>
                  <a @click.prevent="deleteModalMethod(item['id'])" href="#">
                    <img
                        style="transform: translateX(-0.2vw)"
                        class="table-delete-img"
                        src="../../../assets/img/delete.svg"
                        alt="delete"></a>
                  <a :href="`${this.download_url}/${item.file}`" >
                    <Download title="دانلود فایل" style="width: 1.2vw; margin-right: 0.4vw;"/>
                  </a>
                </div>
              </td>
            </tr>

            </tbody>
          </table>
        </div>
        <center v-else>
          مدلی برای فرآیند ها یافت نشد
        </center>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="newModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p> مدلسازی جدید</p>
      <p @click="newModal=!newModal">❌</p>
    </div>
    <div>
      <div style="width: 100%;">
        <label class="text-end w-100">نام مدل خود را وارد کنید:</label>
        <input type="text" class="form-control" v-model="NewName" style="width: 28vw !important;">
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <a @click.prevent="create" class="btn btn-primary btn-back">ایجاد</a>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 55%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="submit_delete">تایید</button>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import cookies from "vue-cookies";
import {useToast} from "vue-toastification";
import splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Download from "@/components/Icons/Download.vue";

const toast = useToast();


export default {
  components: {
    Download,
    Sidebar, splash
  },
  data() {
    return {
      id_user: '',
      newModal: false,
      deleteModal: false,
      NewName: '',
      allItems: [],
      id: '',
      search_keyword: '',

    }
  },
  methods: {
    deleteModalMethod(id) {
      this.id = id
      this.deleteModal = true
    },
    submit_delete() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/design_modeling/destroy/${this.id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.message) {
              this.deleteModal = false
              toast.success(response.message)
              this.all()

            }


          })
          .catch();
    },
    create() {
      if (!this.NewName) {
        return toast.error('عنوان اجباری است!')

      }
      window.location.href = `${this.download_url}/DesignAndModeling/${this.id_user}?token=${this.$cookies.get('id_login')}&name=${this.NewName}`

    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.logout()
              return;
            }
            if (result['item']) {
              if (this.is_mother) {
                this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/design_modeling/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const all = response.all
            this.allItems.length = 0
            if (all) {
              this.allItems.push(...all)
            }


          })
          .catch();
    },
    checkIsMother(){

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/check`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.process===0){
              router.push('/pishkhan')
              return
            }


          })
          .catch();

    }
  }
  ,
  mounted() {
    this.fetchItems()
    this.all()
    this.checkIsMother()


  },
  computed: {
    filteredItems() {
      return this.allItems.filter(item => {
        return (
            item['process']['title'].includes(this.search_keyword) ||
            item['process']['code'].includes(this.search_keyword) ||
            (item['process']['organ_post'] &&
                item['process']['organ_post']['organizationpost'] &&
                item['process']['organ_post']['organizationpost']['name'].includes(this.search_keyword))
        );
      });
    },
  }

}
</script>

